import React from 'react'
import PropTypes from 'prop-types'


const ADACheckbox = ({ children, className, isChecked, disabled, ariaLabel, dataTestId, onClick }) => (
  React.createElement('button', {
    className,
    type: 'button',
    role: 'checkbox',
    'aria-checked': isChecked,
    'aria-disabled': disabled,
    'aria-label': ariaLabel,
    'data-testid': dataTestId,
    onClick,
  }, children)
)

ADACheckbox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}


export default ADACheckbox
